module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="signup-form-step">\n\n  ';
 if (position) { ;
__p += '\n    <div class="featured-position">\n      ';
 if (position.logo_url) { ;
__p += '\n        <div style="background-image: url(' +
__e( position.logo_url ) +
');" class="company-logo"></div>\n      ';
 } ;
__p += '\n\n      <a class="no-underline" href="' +
__e( position.link ) +
'">\n        <h4>' +
__e( position.title ) +
'</h4>\n      </a>\n      <p class="small">\n        ' +
__e( position.company_name ) +
'\n\n        ';
 if (position.city) { ;
__p += '\n          - ' +
__e( position.city ) +
'\n        ';
 } ;
__p += '\n\n        ';
 if (position.wage && position.wage > 0) { ;
__p += '\n          ';
 if (position.city) { ;
__p += '<br />';
 } else { ;
__p += ' - ';
 } ;
__p += '\n          $' +
__e( position.wage ) +
'/hour\n        ';
 } ;
__p += '\n      </p>\n    </div>\n  ';
 } ;
__p += '\n\n  ';
 if (!authUser) { ;
__p += '\n    <p class="login-reminder">\n      Applied on WorkStep before?&nbsp;&nbsp;\n      <a href="/login?redirect=' +
__e( encodeURIComponent(url) ) +
'">\n        Log in\n      </a>\n    </p>\n  ';
 } ;
__p += '\n\n  <div class="form-group">\n    <label for="first_name">First name</label>\n    <input id="first_name" type="text"\n      class="fs-hide"\n      value="' +
__e( first_name ) +
'"\n      autocomplete="given-name"\n      autocorrect="off" />\n    <span class="help-block hidden"></span>\n  </div>\n\n  <div class="form-group">\n    <label for="last_name">Last name</label>\n    <input id="last_name" type="text"\n      class="fs-hide"\n      value="' +
__e( last_name ) +
'"\n      autocomplete="family-name"\n      autocorrect="off" />\n    <span class="help-block hidden"></span>\n  </div>\n\n  <div class="form-group">\n    <label for="phone">\n      Mobile phone number\n      <a href="#" class="js-phone-modal">How is my number used?</a>\n    </label>\n    <input id="phone" type="tel"\n      class="fs-hide"\n      placeholder="617-505-5555"\n      pattern="[0-9]*"\n      inputmode="numeric"\n      value="' +
__e( phone ) +
'" ';
 if (isProfile) { ;
__p += 'disabled';
 } ;
__p += ' >\n    <span class="help-block hidden"></span>\n  </div>\n\n  <div class="form-group">\n    <label for="email">Email address</label>\n    <input id="email" type="email"\n      placeholder="me@example.com"\n      autocapitalize="none"\n      value="' +
__e( email ) +
'"\n      inputmode="email" ';
 if (isProfile) { ;
__p += 'disabled';
 } ;
__p += ' >\n    <span class="help-block hidden"></span>\n  </div>\n\n  <button class="next-button btn btn-large btn-primary">Next</button>\n\n  <div id="tos-container">\n    By clicking \'NEXT,\' you agree to our\n    <a href="/terms" target="_blank">Terms</a> and\n    <a href="/privacy" target="_blank">Privacy Policy</a>\n  </div>\n</div>\n';

}
return __p
}